import { parseServerUtcToLocalDate } from 'src/common/date/serverUtcToLocal';

export function formatDateTimeTwoLines(
  dateTime: string | number | Date | null | undefined
): string {
  if (!dateTime || dateTime === '') {
    return '';
  }

  const date = parseServerUtcToLocalDate(dateTime);
  if (!date) {
    return '';
  }

  const datePart = new Intl.DateTimeFormat('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);

  const timePart = new Intl.DateTimeFormat('ja-JP', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);

  return `${datePart} ${timePart}`;
}
